
import { Link, useLocation } from "react-router-dom";

const tabs = [
    { name: "COD Remittance", path: "/CodRemittances" },
    { name: "Wallet Transactions", path: "/wallettransactions" },
    // { name: "Shipping Charges", path: "/shippingcharges" },
    // { name: "New Weight Reconciliation", path: "/newweightreconciliation" },
    { name: "Early COD Remittance Plan", path: "/earlycodremittanceplan" },
];

const BillingHeader = () => {
    const location = useLocation();


    return (
        <div className="px-6 pt-6 pb-2 bg-white rounded-lg">
            <h2 className="text-xl font-bold">Billing - COD Remittance</h2>

            <div className="mt-4 flex flex-wrap gap-2 border-b">
                {tabs?.map((tab) => (
                    <Link
                        key={tab?.name}
                        to={tab?.path}
                        className={`px-4 py-2 text-sm relative transition-all duration-200 ${location?.pathname === tab?.path
                            ? "font-semibold text-black after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:bg-black"
                            : "text-gray-600 hover:text-black"
                            }`}
                    >
                        {tab?.name}
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default BillingHeader;




